<template>
  <div>
    <ModalRecusarAcesso
      :is-active="modalRecusarActive"
      :item="$route.params.id"
      @confirm="(payload) => confirmRefuse(payload)"
      @cancel="modalRecusarActive = false"
      />
    <div class="is-flex is-justify-content-space-between">
      <b-button
        size="is-small is-success mr-2"
        icon-left="thumb-up"
        @click="$emit('approve')"
      >
        Aprovar
      </b-button>
      <b-button
        size="is-small is-danger mr-2"
        icon-left="thumb-down"
        @click="abrirModalRecusarAcesso"
      >
        Recusar
      </b-button>
    </div>
  </div>
</template>

<script>
import ModalRecusarAcesso from "./Modals/ModalRecusarAcesso.vue";

export default {
  name: "ApproveOrRefuseGroupButtons",
  data() {
    return {
      modalRecusarActive: false,
    };
  },
  components: {
    ModalRecusarAcesso,
  },
  methods: {
    abrirModalRecusarAcesso() {
      this.modalRecusarActive = true;
    },
    confirmRefuse(payload) {
      this.$emit("refuse", payload);
      this.modalRecusarActive = false; // Fecha o modal após a confirmação
    },
  },
};
</script>
